export enum TableMode {
    Normal   = 'normal',
    Detailed = 'detailed',
}

const COOKIE_KEY = 'export_table_mode';
const MAX_AGE    = 365 * 24 * 60 * 60;

export function readTableModeCookie(): TableMode {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_KEY}=([^;]+)`));
    if (match) {
        const val = match[1] as TableMode;
        if (Object.values(TableMode).includes(val)) return val;
    }
    return TableMode.Normal;
}

export function writeTableModeCookie(mode: TableMode): void {
    document.cookie = `${COOKIE_KEY}=${mode}; path=/; max-age=${MAX_AGE}`;
}
